import type { ConfigContact } from '@bb/domain/dist/types/AppointmentConfig';
import axios from 'axios';
import { invalidateListingAppointmentConfigCache } from './getListingAppointmentConfig';

type SaveConfigContactParams = {
  listingId: string;
  contactId: string;
};

const saveConfigContact = async (
  params: SaveConfigContactParams,
  body: ConfigContact,
) => {
  const { data } = await axios.request({
    url: `/appointments/${params.listingId}/config/contacts/${params.contactId}`,
    method: 'post',
    data: body,
  });

  invalidateListingAppointmentConfigCache(params.listingId);

  return data;
};

export default saveConfigContact;
